import { useRouterStore } from "../store/useRouterStore";
import { Color } from "three";
import { useComponentLoadingStateStore } from "../store/useComponentLoadingStateStore";

export const BOOTH_HIGHLIGHT_COLOR = new Color("#94b0f7").convertSRGBToLinear();
export const BOOTH_UNHIGHLIGHT_COLOR = new Color("#ffffff");

export const handleBoothHover = (e: any, boothObject: any) => {
  e.stopPropagation();
  const boothID = useRouterStore.getState().boothID;
  if (boothID !== "" || !boothObject) return;
  document.body.style.cursor = "pointer";
  boothObject.children.forEach((mesh: any) => {
    if (!mesh.material) return;
    const newMaterial = mesh.material.clone();
    const meshName = mesh.name.split("-")[0];
    if (meshName === "tv" || meshName === "offer") return;
    mesh.material = newMaterial;
    newMaterial.color = BOOTH_HIGHLIGHT_COLOR;
    newMaterial.needsUpdate = true;
  });
};

export const handleBoothUnhover = (e: any, boothObject: any) => {
  if (e !== undefined) {
    e.stopPropagation();
  }
  document.body.style.cursor = "auto";
  const isBoothVisitPartActive =
    useComponentLoadingStateStore.getState().isBoothVisitPartActive;
  if (isBoothVisitPartActive || !boothObject) return;
  boothObject.children.forEach((mesh: any) => {
    if (!mesh.material) return;
    const meshName = mesh.name.split("-")[0];
    if (meshName === "tv" || meshName === "offer") return;
    mesh.material.color = BOOTH_UNHIGHLIGHT_COLOR;
    mesh.material.needsUpdate = true;
  });
};

export const blurHorizontalBannerImage = (object: any, blurValue: string) => {
  if (!object) return;
  if (blurValue === "blur") {
    object.material.color = new Color("#6b6b6b");
    return;
  }
  if (blurValue === "remove-blur") {
    object.material.color = new Color("#ffffff");
    return;
  }
};
